import TweenMax from 'gsap/TweenMax';
import EasePack from 'gsap/EasePack';

export default function Baseball(container, canvas, duration, beforeAnimation) {
  const baseballImage = container.getElementsByClassName('baseball-0')[0];
  const {
    top: containerTop,
    left: containerLeft,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const { top: canvasTop, right: canvasRight } = canvas.getBoundingClientRect();

  const initialX = canvasRight - containerLeft - containerWidth;
  const initialY = containerTop - canvasTop + 50;
  const initialBaseballX = -170;
  const initialBaseballY = 110;

  TweenMax.set(baseballImage, {
    x: initialBaseballX,
    y: initialBaseballY,
  });

  beforeAnimation(initialX, initialY);

  TweenMax.set(container, { opacity: 1 });

  TweenMax.to(baseballImage, duration, {
    x: initialBaseballX + 100,
    ease: EasePack.Power0.easeNone,
  });
}
